module.exports = __webpack_public_path__ + "media/images/responsive/fairs/cv/icon_unavailable-0ae30146e4d4b70fe2154cc0f95fc84a.svg";